import { parseClockTime } from "./geofenceUtils";
import { ResolveExceptionRequest } from "../services/request/AttendanceExceptionsRequest";

/** Convert minutes-of-day to a zero-padded "HH:MM:SS" string for the API. */
export const formatTimeAsHHMMSS = (totalMinutes: number): string => {
  const wrapped = ((Math.round(totalMinutes) % 1440) + 1440) % 1440;
  const h = Math.floor(wrapped / 60);
  const m = wrapped % 60;
  return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}:00`;
};

/**
 * Map a modal's (exceptionType, action, reason) into the resolve request body.
 *
 * - Time-carrying actions (geofence `clock_override`, and `clock_in` for
 *   no_data / no_show) parse the entered time from `reason` and send it as
 *   `confirmed_clock_time`. Returns `null` when the time can't be parsed so the
 *   caller can surface an "invalid input" message.
 * - `mark_as_other` sends the free-text `reason` (required).
 * - Everything else passes `reason` through verbatim when present.
 */
export const buildResolveBody = (
  exceptionType: string,
  action: string,
  reason?: string
): ResolveExceptionRequest | null => {
  const isClockTimeAction =
    (exceptionType === "geofence" && action === "clock_override") ||
    action === "clock_in";
  if (isClockTimeAction) {
    if (!reason || !reason.trim()) return null;
    const minutes = parseClockTime(reason);
    if (minutes === null || minutes < 0) return null;
    return {
      action: action as ResolveExceptionRequest["action"],
      confirmed_clock_time: formatTimeAsHHMMSS(minutes),
    };
  }
  if (action === "mark_as_other") {
    if (!reason || !reason.trim()) return null;
    return {
      action: action as ResolveExceptionRequest["action"],
      reason,
    };
  }
  return {
    action: action as ResolveExceptionRequest["action"],
    ...(reason ? { reason } : {}),
  };
};
